// src/components/NowPlaying.js
import React, { useEffect, useState, useMemo } from 'react';
import { useWebSocket } from '../hooks/useWebSocket';
import { WS_URL } from '../config';
import SongList from './SongList';
import HLSPlayer from '../components/HLSPlayer';
import { useAuth } from '../hooks/useAuth';

export default function NowPlaying() {
  const data = useWebSocket(WS_URL);
  const { isFavorited, toggleFavorite } = useAuth();
  const [remaining, setRemaining] = useState(0);

  const song = useMemo(() => {
    return data?.type === 'playback_update' ? data.now_playing : null;
  }, [data]);

  useEffect(() => {
    if (!song) return;
    const endTime = song.start_time + song.length;
    const updateRemaining = () => {
      const now = Math.floor(Date.now() / 1000);
      const diff = endTime - now;
      setRemaining(diff > 0 ? diff : 0);
    };
    updateRemaining();
    const interval = setInterval(updateRemaining, 1000);
    return () => clearInterval(interval);
  }, [song]);

  if (!song) {
    return (
      <div>
        <img src="/emoji/23F3.svg" alt="Waiting" className="inline w-5 h-5 mr-1 align-text-bottom" />
        Waiting for now playing data...
      </div>
    );
  }

  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;

  return (
    <div>
      <h2 className="text-lg font-semibold mb-2">Now Playing</h2>
      <SongList songs={[song]} onToggleFavorite={toggleFavorite} isFavorited={isFavorited} showRequestButton={false} compact />
      <div className="text-sm text-gray-600 mt-1">
        <img src="/emoji/23F1.svg" alt="Time remaining" className="inline w-4 h-4 mr-1 align-text-bottom" />
        Time remaining: {minutes}:{seconds.toString().padStart(2, '0')}
      </div>
      <div className="p-4">
        <h1 className="text-xl font-bold mb-4">
          <img src="/emoji/1F4FB.svg" alt="Live Stream" className="inline w-6 h-6 mr-2 align-text-bottom" />
          Live Stream
        </h1>
        <HLSPlayer currentSong={song} />
      </div>
    </div>
  );
}
